import { lazy } from 'react';

const ChartMapsRoutes = [
  {
    path: '/payment-confirm',
    component: lazy(() => import('../../views/pages/Payment/PaymentSuccess')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
  {
    path: '/payment-failed',
    component: lazy(() => import('../../views/pages/Payment/PaymentFailed')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
    },
  },
];

export default ChartMapsRoutes;
